import { Chart } from 'primereact/chart';
import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { ApiGet } from '../../helper/API/ApiData';
import { handleError } from '../../utils/helper';
import { FaRegRegistered } from "react-icons/fa";
import { MdGroups } from "react-icons/md";
import { title } from 'process';
import { useNavigate } from 'react-router-dom';

const ShgDashboard = ({ showChart = true }: { showChart?: boolean }) => {
    const navigate = useNavigate()

    const [totalCount, setTotalCount] = useState({
        totalShg: 0,
        registeredShg: 0,
        totalShgMembers: 0,
        totalInterlending: 0,
        totalLoanReceived: 0,
        totalAmountSaved: 0,
    });
    const [shgChartData, setShgChartData] = useState({});
    const [amountChartData, setAmountChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);

        ApiGet(`shg/dashboard`)
            .then((res: any) => {
                if (res?.status === 200) {
                    console.log("🚀 ~ .then ~ res.data[0].shgDetails:", res.data[0].shgDetails)
                    setTotalCount(res.data[0].shgDetails)

                    const shgChartLabelList: string[] = Object.keys(res.data[0].chart.shgFormationData)
                    const shgChartDataList: number[] = Object.values(res.data[0].chart.shgFormationData)

                    const amountSavedLabelList: string[] = Object.keys(res.data[0].chart.amountSavedChart)
                    const amountSavedDataList: number[] = Object.values(res.data[0].chart.amountSavedChart)

                    setShgChartData({
                        labels: shgChartLabelList,
                        datasets: [
                            {
                                data: shgChartDataList,
                                backgroundColor: [
                                    documentStyle.getPropertyValue('--blue-500'),
                                    documentStyle.getPropertyValue('--yellow-500'),
                                    documentStyle.getPropertyValue('--green-500')
                                ],
                                hoverBackgroundColor: [
                                    documentStyle.getPropertyValue('--blue-400'),
                                    documentStyle.getPropertyValue('--yellow-400'),
                                    documentStyle.getPropertyValue('--green-400')
                                ]
                            }
                        ]
                    })

                    setAmountChartData({
                        labels: amountSavedLabelList,
                        datasets: [
                            {
                                data: amountSavedDataList,
                                backgroundColor: [
                                    documentStyle.getPropertyValue('--blue-500'),
                                    documentStyle.getPropertyValue('--yellow-500'),
                                    documentStyle.getPropertyValue('--green-500')
                                ],
                                hoverBackgroundColor: [
                                    documentStyle.getPropertyValue('--blue-400'),
                                    documentStyle.getPropertyValue('--yellow-400'),
                                    documentStyle.getPropertyValue('--green-400')
                                ]
                            }
                        ]
                    })


                    const options = {
                        plugins: {
                            legend: {
                                display: false
                            },
                            title: {
                                display: true,
                                text: 'SHG Formation',
                            }
                        }
                    };

                    setChartOptions(options);
                }
            })
            .catch((error) => {
                handleError(error)
                return error
            })

    }, [])


    const gotoShg = () => {
        navigate('/shgadmin/shg')
    }


    return (
        <Container fluid className="p-3">
            <h4 className="page-title">SHG'S Details</h4>
            <Row>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoShg()}>
                        <Card.Body style={{ backgroundColor: '#609ea2' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-users" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of SHG'S</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalShg}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoShg()}>
                        <Card.Body style={{ backgroundColor: '#28a745' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <MdGroups style={{ fontSize: '2.5rem', color: '#fff' }} />
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of SHG Members</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalShgMembers}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoShg()}>
                        <Card.Body style={{ backgroundColor: '#141E46' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <FaRegRegistered style={{ fontSize: '2.5rem', color: '#fff' }} />
                                    {/* <i className="fa-regular fa-registered" ></i> */}
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of SHG'S registered</p>
                                        <h4 className="mb-0 card-title">{totalCount.registeredShg}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>

            </Row>
            <Row className='mt-4'>

                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoShg()}>
                        <Card.Body style={{ backgroundColor: '#fff' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-chart-pie" style={{ fontSize: '2.5rem', color: 'orange' }}></i>
                                </Col>
                                <Col md={7}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#9A9A9A' }}>Amount In Interlending</p>
                                        <h4 className="mb-0 card-title" style={{ color: "#575962" }}>₹ {totalCount.totalInterlending}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoShg()}>
                        <Card.Body style={{ backgroundColor: '#fff' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-chart-bar" style={{ fontSize: '2.5rem', color: 'green' }}></i>
                                </Col>
                                <Col md={7}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#9A9A9A' }}>Amount Saved by the SHG'S</p>
                                        <h4 className="mb-0 card-title" style={{ color: "#575962" }}>₹ {totalCount.totalAmountSaved}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4} style={{ cursor: "pointer" }} onClick={() => gotoShg()}>
                    <Card>
                        <Card.Body style={{ backgroundColor: '#fff' }}>
                            <Row>
                                {/* <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-times-circle" style={{ fontSize: '2.5rem', color: 'red' }}></i>
                                </Col> */}
                                <Col md={12}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#9A9A9A' }}>Amount received as loan</p>
                                        <h4 className="mb-0 card-title" style={{ color: "#575962" }}>₹ {totalCount.totalLoanReceived}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
            </Row>
            {showChart &&
                <Row className='mt-4'>
                    <Col md={6} style={{}}>
                        <Card>
                            <Card.Body>
                                <Chart type="bar" data={shgChartData} options={{
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        title: {
                                            display: true,
                                            text: "No of SHG's formed",
                                            font: {
                                                size: 17
                                            }
                                        }
                                    }
                                }} />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6} style={{}}>
                        <Card>
                            <Card.Body style={{}}>
                                <Chart type="line" data={amountChartData} options={{
                                    plugins: {
                                        legend: {
                                            display: false
                                        },
                                        title: {
                                            display: true,
                                            text: "Amount Saved by the SHG's",
                                            font: {
                                                size: 17
                                            }
                                        }
                                    }
                                }} />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            }

        </Container >
    )
}

export default ShgDashboard